<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex md12>
              <v-btn
                fixed
                direction="bottom"
                dark
                fab
                bottom
                right
                color="pink"
                @click="guardar"
                :disabled="horario.length <= 0"
                v-show="$mq !== 'sm'"
                large
              >
                <v-icon>save</v-icon>
              </v-btn>
                <v-card v-if="!cargandoDatos && !seleccionTerminada && !fueraDeTiempo">
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Reinscripción al semestre: {{periodo.semestre}}</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-layout>
                            <v-flex md6>
                                Por favor selecciona las materias que deseas cursar.<br>
                                <v-chip color="green" text-color="white" disabled>
                                    <v-avatar class="green darken-4">{{creditos}}</v-avatar>
                                    Créditos disponibles
                                </v-chip>
                                <v-chip color="red" text-color="white" disabled v-if="especiales">
                                    <v-avatar class="red darken-4">{{especiales.length}}</v-avatar>
                                    En Curso Especial
                                </v-chip>

                                <v-chip color="orange" text-color="white" disabled v-if="repeticion">
                                    <v-avatar class="orange darken-4">{{repeticion.length}}</v-avatar>
                                    En Repetición
                                </v-chip>
                            </v-flex>
                            <v-flex md6>
                              <CountDown v-model="horaFinal" v-on:time-expire="handleTimeExpire" v-if="enableCountDown"></CountDown>
                            </v-flex>
                        </v-layout>
                        <v-alert
                                :value="true"
                                color="info"
                                icon="info"
                                outline
                        >
                            Recuerda que debes de <strong>Guardar</strong> tu horario o de lo contrario no será oficial.
                        </v-alert>
                        <v-btn color="cyan accent-4" class="white--text" large @click="guardarMaterias" :disabled="horario.length <= 0" block v-show="$mq === 'sm'">Guardar</v-btn>
                    </v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="horario"
                      hide-actions
                      class="my-1 pb-5"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <strong>{{props.item.nombre}}</strong><br>
                          {{props.item.clave}}
                        </td>
                        <td>{{props.item.grupo}}</td>
                        <td>{{ convertirHorario(props.item.horario[2]) }}</td>
                        <td>{{ convertirHorario(props.item.horario[3]) }}</td>
                        <td>{{ convertirHorario(props.item.horario[4]) }}</td>
                        <td>{{ convertirHorario(props.item.horario[5]) }}</td>
                        <td>{{ convertirHorario(props.item.horario[6]) }}</td>
                        <td>{{ convertirHorario(props.item.horario[7]) }}</td>
                        <td>{{ convertirHorario(props.item.horario[1]) }}</td>
                      </template>
                    </v-data-table>
                    <v-layout>
                        <v-flex xs12 sm6>
                            <v-card flat>
                                <v-toolbar color="indigo" dark flat>
                                    <v-toolbar-title>Materias disponibles</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            placeholder="Buscar"
                                            single-line
                                            hide-details
                                            :append-icon="'search'"
                                            clearable
                                    ></v-text-field>
                                </v-toolbar>
                                <v-list three-line>
                                    <template v-for="item in filtering">
                                        <v-list-tile @click="verificaCupoGrupo(materiasDisponibles.indexOf(item))" ripple>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    <span v-html="item.nombre + ' - ' + item.grupo"></span>
                                                    <v-chip v-if="item.tipoRepeticion === 'E'" color="red" class="white--text pa-0 mt-0 v-chip--x-small" disabled>
                                                        Especial
                                                    </v-chip>
                                                    <v-chip v-if="item.tipoRepeticion === 'S'" color="orange" class="white--text pa-0 mt-0 v-chip--x-small" disabled>
                                                        Repetición
                                                    </v-chip>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    <span>Créditos: {{item.creditos}} / Docente: {{item.docente}}</span><br>
                                                    <span v-if="item.horario[2]">L: {{ convertirHorario(item.horario[2]) }}</span>
                                                    <span v-if="item.horario[3]">M: {{ convertirHorario(item.horario[3]) }}</span>
                                                    <span v-if="item.horario[4]">MI: {{ convertirHorario(item.horario[4]) }}</span>
                                                    <span v-if="item.horario[5]">J: {{ convertirHorario(item.horario[5]) }}</span>
                                                    <span v-if="item.horario[6]">V: {{ convertirHorario(item.horario[6]) }}</span>
                                                    <span v-if="item.horario[7]">S: {{ convertirHorario(item.horario[7]) }}</span>
                                                    <span v-if="item.horario[1]">D: {{ convertirHorario(item.horario[1]) }}</span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>

                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-card flat>
                                <v-toolbar>
                                    <v-toolbar-title>Materias Seleccionadas</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="resetSeleccion" flat v-if="horario.length">
                                        <v-icon>cached</v-icon>
                                        Volver a comenzar
                                    </v-btn>
                                </v-toolbar>
                                <v-list three-line>
                                    <template v-for="item in horario">
                                        <v-list-tile @click="quitaAlumno(horario.indexOf(item))" ripple>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    <span v-html="item.nombre + ' - ' + item.grupo"></span>
                                                    <v-chip v-if="item.tipoRepeticion === 'E'" color="red" class="white--text pa-0 mt-0 v-chip--x-small" disabled>
                                                        Especial
                                                    </v-chip>
                                                    <v-chip v-if="item.tipoRepeticion === 'S'" color="orange" class="white--text pa-0 mt-0 v-chip--x-small" disabled>
                                                        Repetición
                                                    </v-chip>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    <span>Créditos: {{item.creditos}} / Docente: {{item.docente}}</span><br>
                                                    <span v-if="item.horario[2]">L: {{ convertirHorario(item.horario[2]) }}</span>
                                                    <span v-if="item.horario[3]">M: {{ convertirHorario(item.horario[3]) }}</span>
                                                    <span v-if="item.horario[4]">MI: {{ convertirHorario(item.horario[4]) }}</span>
                                                    <span v-if="item.horario[5]">J: {{ convertirHorario(item.horario[5]) }}</span>
                                                    <span v-if="item.horario[6]">V: {{ convertirHorario(item.horario[6]) }}</span>
                                                    <span v-if="item.horario[7]">S: {{ convertirHorario(item.horario[7]) }}</span>
                                                    <span v-if="item.horario[1]">D: {{ convertirHorario(item.horario[1]) }}</span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>
                <v-card v-if="seleccionTerminada && !fueraDeTiempo">
                    <v-card-title class="headline">
                        Felicidades
                    </v-card-title>
                  <v-card-text>
                    Tu horario se encuentra en proceso de validación por parte de la División de Estudios Profesionales. <br>
                    Cuando tu carga se encuentre validada podrás imprimirla en la sección <a href="#/information/horario">Horario</a>
                  </v-card-text>
                </v-card>
                <v-card v-if="!cargandoDatos && fueraDeTiempo">
                    <v-card-title class="headline">
                        Selección de Materias
                    </v-card-title>
                    <v-card-text>
                        Te encuentras fuera de tiempo para seleccionar tus materias, regresa más tarde.
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="snackbar.show"
                color="error"
                :timeout="snackbar.timeout"
                :vertical="true"
                :left="true"
                :top="true"
        >
            {{ snackbar.text }}
            <v-btn
                    dark
                    flat
                    @click="snackbar.show = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
        <v-dialog v-model="cruceHorarios" max-width="350px" persistent>
            <v-card>
                <v-card-title class="headline red--text">
                    Cruce de horarios
                </v-card-title>

                <v-card-text>
                    La materia <strong>{{ materiaSeleccionada.nombre + ' ' + materiaSeleccionada.grupo}}</strong> que elegiste cruza con
                    <strong> {{ materiaCargada.nombre + ' ' + materiaCargada.grupo }} </strong> cargada anteriormente.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red"
                            flat
                            @click="cruceHorarios = false"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="cargandoDatos" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Cargando Grupos Disponibles</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="verificandoCupo" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Verificando el cupo del grupo.</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="eliminandoGrupo" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Eliminando del grupo.</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="guardandoMaterias" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Guardando materias.</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="adeudaEspeciales" max-width="250px" persistent>
            <v-card>
                <v-card-title class="headline red--text">
                    Debes uno o más especiales.
                </v-card-title>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red"
                            flat
                            @click="adeudaEspeciales = false"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="adeudaMaterias" max-width="350px" persistent>
            <v-card>
                <v-card-title class="headline red--text">
                    Debes una o más materias en repetición.
                </v-card-title>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red"
                            flat
                            @click="adeudaMaterias = false"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="limiteEspeciales" max-width="350px" persistent>
            <v-card>
                <v-card-title class="headline red--text">
                    Has alcanzado el límite de materias en curso especial que puedes tomar. Por favor guarda tu horario.
                </v-card-title>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="red"
                            flat
                            @click="limiteEspeciales = false"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      <v-dialog v-model="aviso" max-width="350px" persistent>
        <v-card>
          <v-card-title class="headline">
            Importante
          </v-card-title>

          <v-card-text>
            Recuerda que debes de <strong>Guardar</strong>
            <v-icon>save</v-icon>
            tu horario o de lo contrario no será oficial.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="aviso = false"
            >
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="aceptarGuardar" max-width="350px" persistent>
        <v-card>
          <v-card-title class="headline">
            Importante
          </v-card-title>

          <v-card-text>
            Al guardar mi horario estoy de acuerdo con las materias tomadas.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="aceptarGuardar = false"
            >
              No
            </v-btn>
            <v-btn
              color="primary"
              @click="guardarMaterias"
            >
              Sí, estoy de acuerdo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import * as moment from 'moment'
  import CountDown from '../../components/Countdown'

  export default {
    name: 'ReinscripcionPage',
    components: {CountDown},
    data: () => ({
      aviso: false,
      aceptarGuardar: false,
      cargandoDatos: false,
      headers: [
        {
          text: 'Materia',
          align: 'left',
          value: 'materia'
        },
        { text: 'Gpo', value: 'grupo' },
        { text: 'Lunes', value: 'lunes' },
        { text: 'Martes', value: 'martes' },
        { text: 'Miércoles', value: 'miercoles' },
        { text: 'Jueves', value: 'jueves' },
        { text: 'Viernes', value: 'viernes' },
        { text: 'Sábado', value: 'sabado' },
        { text: 'Domingo', value: 'domingo' }
      ],
      horario: [],
      materiasDisponibles: [],
      periodo: {},
      creditos: 0,
      creditosInsuficientes: false,
      search: '',
      cruceHorarios: false,
      materiaCargada: '',
      materiaSeleccionada: '',
      especiales: [],
      especialesCargados: [],
      adeudaEspeciales: false,
      repeticion: [],
      repeticionesCargadas: [],
      adeudaMaterias: false,
      verificandoCupo: false,
      eliminandoGrupo: false,
      guardandoMaterias: false,
      seleccionTerminada: false,
      horaFinal: '',
      fueraDeTiempo: false,
      limiteEspeciales: false,
      snackbar: {
        show: false,
        timeout: 6000,
        text: ''
      }
    }),
    created () {
      const materiasDisponibles = JSON.parse(sessionStorage.getItem('materiasDisponibles'))
      const countdown = JSON.parse(localStorage.getItem('horaFinal')) || { horaFinal: '', periodo: '' }

      if (materiasDisponibles) {
        this.horaFinal = countdown.horaFinal
        this.creditos = parseInt(sessionStorage.getItem('creditos'))
        this.periodo = JSON.parse(sessionStorage.getItem('periodo'))
        this.horario = JSON.parse(sessionStorage.getItem('horario')) || []
        this.especiales = JSON.parse(sessionStorage.getItem('especiales'))
        this.especialesCargados = JSON.parse(sessionStorage.getItem('especialesCargados'))
        this.repeticion = JSON.parse(sessionStorage.getItem('repeticion'))
        this.repeticionesCargadas = JSON.parse(sessionStorage.getItem('repeticionesCargadas'))
        this.materiasDisponibles = materiasDisponibles
        this.seleccionTerminada = sessionStorage.getItem('seleccionTerminada') || false
      } else {
        this.getGruposDisponibles()
      }
    },
    watch: {
      periodo (value) {
        let countdown = JSON.parse(localStorage.getItem('horaFinal')) || { horaFinal: moment().format('Y-MM-DD HH:mm:ss'), periodo: '' }

        if (countdown.periodo !== value.periodo) {
          let horaFinal = moment()
          horaFinal.add(20, 'm')
          countdown.horaFinal = horaFinal.format('Y-MM-DD HH:mm:ss')
          countdown.periodo = value.periodo
          localStorage.setItem('horaFinal', JSON.stringify(countdown))
        }

        this.horaFinal = countdown.horaFinal
      }
    },
    computed: {
      filtering () {
        if (this.search) {
          return this.materiasDisponibles.filter((item) => {
            return (item.nombre.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) ||
              (item.clave.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) ||
              (item.grupo.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
          })
        }

        return this.materiasDisponibles
      },
      enableCountDown () {
        const dayEnable = moment('2020-09-14 00:00')
        return moment().isAfter(dayEnable)
      }
    },
    methods: {
      moverAHorario: function (index) {
        this.search = ''

        const grupo = this.materiasDisponibles[index]
        this.creditos -= grupo.creditos

        if (index >= 0) {
          this.horario.push(grupo)
          this.materiasDisponibles.splice(index, 1)
        } else {
          for (let cont = 0; cont < this.materiasDisponibles.length; cont++) {
            this.horario.push(this.materiasDisponibles[cont])
          }
          this.materiasDisponibles.splice(0, this.materiasDisponibles.length)
        }

        switch (grupo.tipoRepeticion) {
          case 'E':
            this.especialesCargados.push(grupo.clave)
            break
          case 'S':
            this.repeticionesCargadas.push(grupo.clave)
            break
        }

        sessionStorage.setItem('horario', JSON.stringify(this.horario))
        sessionStorage.setItem('materiasDisponibles', JSON.stringify(this.materiasDisponibles))
        sessionStorage.setItem('creditos', this.creditos)
        sessionStorage.setItem('especiales', JSON.stringify(this.especiales))
        sessionStorage.setItem('especialesCargados', JSON.stringify(this.especialesCargados))
        sessionStorage.setItem('repeticion', JSON.stringify(this.repeticion))
        sessionStorage.setItem('repeticionesCargadas', JSON.stringify(this.repeticionesCargadas))
      },
      moverAMaeriasDisponibles: function (index) {
        this.search = ''
        this.creditos += this.horario[index].creditos
        const grupo = this.horario[index]
        if (index >= 0) {
          this.materiasDisponibles.push(grupo)
          this.horario.splice(index, 1)
        } else {
          for (let cont = 0; cont < this.horario.length; cont++) {
            this.materiasDisponibles.push(this.horario[cont])
          }
          this.horario.splice(0, this.horario.length)
        }

        index = this.repeticionesCargadas.indexOf(grupo.clave)
        if (index !== -1) {
          this.repeticionesCargadas.splice(index, 1)
        }

        sessionStorage.setItem('horario', JSON.stringify(this.horario))
        sessionStorage.setItem('materiasDisponibles', JSON.stringify(this.materiasDisponibles))
        sessionStorage.setItem('creditos', this.creditos)
        sessionStorage.setItem('especiales', JSON.stringify(this.especiales))
        sessionStorage.setItem('especialesCargados', JSON.stringify(this.especialesCargados))
        sessionStorage.setItem('repeticion', JSON.stringify(this.repeticion))
        sessionStorage.setItem('repeticionesCargadas', JSON.stringify(this.repeticionesCargadas))
      },
      getGruposDisponibles () {
        this.cargandoDatos = true
        axios.get('alumno/grupos-disponibles')
          .then(request => {
            const materiasSeleccionadasAnteriormente = request.data.materiasSeleccionadasAnteriormente
            const that = this

            if (!request.data.autorizaEscolar) {
              this.fueraDeTiempo = true
              this.cargandoDatos = false
              this.snackbar.show = true
              this.snackbar.text = 'Aún no se ha registrado tu pago.'
              return
            }

            this.cargandoDatos = false
            this.materiasDisponibles = request.data.grupos
            this.periodo = request.data.periodo
            this.creditos = request.data.creditos
            this.especiales = request.data.especiales
            this.repeticion = request.data.repeticion
            this.seleccionTerminada = request.data.seleccionTerminada
            this.fueraDeTiempo = request.data.fueraDeTiempo

            sessionStorage.setItem('periodo', JSON.stringify(this.periodo))

            materiasSeleccionadasAnteriormente.forEach(function (item) {
              const materia = that.materiasDisponibles.filter(function (grupo) {
                return (grupo.clave.toLowerCase().indexOf(item.clave.toLowerCase()) !== -1) &&
                  (grupo.grupo.toLowerCase().indexOf(item.grupo.toLowerCase()) !== -1)
              })

              that.moverAHorario(that.materiasDisponibles.indexOf(materia.pop()))
            })
          })
      },
      convertirHorario (horario) {
        if (horario.horaInicial === undefined) {
          return ''
        }

        return horario.horaInicial + ' - ' + horario.horaFinal + ' (' + horario.aula + ')'
      },
      validaHorarios (horarioA, horarioB, resolve, reject) {
        const horaInicial = moment(horarioA.horaInicial, 'HH:mm')
        const horaFinal = moment(horarioA.horaFinal, 'HH:mm')

        const horaInicialGrupo = moment(horarioB.horaInicial, 'HH:mm')
        const horaFinalGrupo = moment(horarioB.horaFinal, 'HH:mm')

        if (horaInicial.isValid() && horaFinal.isValid() &&
          horaInicialGrupo.isValid() && horaFinalGrupo.isValid()) {
          if (!this.cruceHorarios) {
            this.cruceHorarios = horaInicialGrupo.isBetween(horaInicial, horaFinal, null, '[)') || horaInicial.isBetween(horaInicialGrupo, horaFinalGrupo, null, '[)')
          }
          if (!this.cruceHorarios) {
            this.cruceHorarios = horaFinalGrupo.isBetween(horaInicial, horaFinal, null, '(]') || horaFinal.isBetween(horaInicialGrupo, horaFinalGrupo, null, '(]')
          }
          if (this.cruceHorarios) {
            reject()
          } else {
            resolve()
          }
        } else {
          resolve()
        }
      },
      comparaGrupos (grupoA, grupoB, resolve1, reject1) {
        let horarios = []
        for (let index in grupoA.horario) {
          const p = new Promise((resolve, reject) => {
            this.validaHorarios(grupoA.horario[index], grupoB.horario[index], resolve, reject)
          })
          horarios.push(p)
        }

        Promise.all(horarios)
          .then(() => {
            resolve1(grupoA)
          })
          .catch(() => {
            reject1([grupoA, grupoB])
          })
      },
      verificaCruce (grupo) {
        const grupos = this.horario.map(g => {
          return new Promise((resolve, reject) => {
            this.comparaGrupos(g, grupo, resolve, reject)
          })
        })

        return Promise.all(grupos)
      },
      verificaCupoGrupo (index) {
        this.verificandoCupo = true
        const grupo = this.materiasDisponibles[index]

        if (this.especialesCargados.length >= 2) {
          this.verificandoCupo = false
          this.limiteEspeciales = true
          return
        }

        if (this.materiaRepetida(grupo.clave)) {
          this.verificandoCupo = false
          this.snackbar.show = true
          this.snackbar.text = 'No puedes tomar dos veces una misma materia.'
          return false
        }

        this.verificaCruce(grupo)
          .then(() => {
            const verificaCreditos = this.creditos - grupo.creditos
            if (verificaCreditos <= -1) {
              this.verificandoCupo = false
              this.creditosInsuficientes = true
              return
            }

            const especialesPendientes = this.especiales.filter(clave => {
              return this.especialesCargados.indexOf(clave) === -1
            })

            const repeticionesPendientes = this.repeticion.filter(clave => {
              return this.repeticionesCargadas.indexOf(clave) === -1
            })

            if (especialesPendientes.length >= 1 && especialesPendientes.indexOf(grupo.clave) === -1) {
              this.verificandoCupo = false
              this.adeudaEspeciales = true
              return
            }

            if (repeticionesPendientes.length >= 1 && especialesPendientes.length === 0 && repeticionesPendientes.indexOf(grupo.clave) === -1) {
              this.verificandoCupo = false
              this.adeudaMaterias = true
              return
            }

            console.log('RESERVANDO GRUPO', {
              grupo: grupo.grupo,
              materia: grupo.clave,
              periodo: this.periodo.periodo
            })
            axios.post('alumno/inscripcion/reserva-cupo', {
              grupo: grupo.grupo,
              materia: grupo.clave,
              periodo: this.periodo.periodo
            })
              .then(() => {
                this.moverAHorario(index)
              })
              .catch(err => {
                console.log('No se pudo reservar el cupo en el grupo')
                console.log(err.response)
                if (err.response) {
                  console.log(err.response.data.mensaje)
                  this.snackbar.show = true
                  this.snackbar.text = err.response.data.mensaje
                }
              })
              .finally(() => {
                this.verificandoCupo = false
              })
          })
          .catch(values => {
            if (Array.isArray(values)) {
              this.materiaCargada = values[0]
              this.materiaSeleccionada = values[1]
            } else {
              console.log(values)
            }
            this.verificandoCupo = false
          })
      },
      quitaAlumno (index) {
        this.eliminandoGrupo = true
        const grupo = this.horario[index]

        if (this.especialesCargados.indexOf(grupo.clave) !== -1) {
          console.log('No se puede eliminar un especial')
          this.eliminandoGrupo = false
          return
        }

        axios.post('alumno/inscripcion/quita-alumno', {grupo: grupo.grupo, materia: grupo.clave, periodo: this.periodo.periodo})
          .then(() => {
            this.eliminandoGrupo = false
            this.moverAMaeriasDisponibles(index)
          })
          .catch(err => {
            this.eliminandoGrupo = false
            console.log('No se pudo eliminar del grupo')
            console.log(err.data)
          })
      },
      resetSeleccion () {
        this.eliminandoGrupo = true
        const that = this
        console.log('RESET')
        const horarios = this.horario.map(grupo => {
          if (that.especialesCargados.indexOf(grupo.clave) !== -1) {
            return new Promise((resolve, reject) => { resolve() })
          }

          return new Promise((resolve, reject) => {
            axios.post('alumno/inscripcion/quita-alumno', {grupo: grupo.grupo, materia: grupo.clave, periodo: this.periodo.periodo})
              .then(() => {
                console.log('eliminando grupo')
                const index = this.horario.indexOf(grupo)
                this.moverAMaeriasDisponibles(index)
                resolve()
              })
              .catch(err => {
                console.log('No se pudo eliminar del grupo')
                console.log(err.data)
                resolve()
              })
          })
        })

        Promise.all(horarios)
          .then(() => {
            this.eliminandoGrupo = false
          })
          .catch(() => {
            this.eliminandoGrupo = false
          })
      },
      guardar () {
        this.aceptarGuardar = true
      },
      guardarMaterias () {
        this.aceptarGuardar = false
        if (this.especialesCargados.length > 2) {
          this.verificandoCupo = false
          this.adeudaMaterias = true
          return
        }

        if (this.horario.length) {
          this.guardandoMaterias = true
          axios.post('alumno/inscripcion/guardar', {horario: this.horario, periodo: this.periodo.periodo})
            .then(response => {
              this.guardandoMaterias = false
              this.seleccionTerminada = true
              sessionStorage.setItem('seleccionTerminada', this.seleccionTerminada)
              console.log(response.data)
            })
            .catch(err => {
              console.log(err.data)
            })
        }
      },
      materiaRepetida (clave) {
        const especialDuplicado = this.especialesCargados.find(materia => {
          return materia === clave
        })

        const materiaDuplicada = this.horario.find(materia => {
          return materia.clave === clave
        })

        const repeticionDuplicada = this.repeticionesCargadas.find(materia => {
          return materia === clave
        })

        return especialDuplicado !== undefined || materiaDuplicada !== undefined || repeticionDuplicada !== undefined
      },
      handleTimeExpire () {
        alert('El tiempo para seleccionar materias ha terminado.')
        this.guardarMaterias()
      }
    }
  }
</script>

<style scoped>
    .v-list.v-list--three-line {
        max-height: 600px;
        overflow-y: auto;
    }

    .v-chip--x-small {
        font-size: 10px;
        height: 16px;
    }

    .v-chip--x-small .v-chip__content {
        line-height: 1;
        padding: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/inscripciones/ReinscripcionPage.vue